import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../../common/html/element'
import { Icon } from '../../../../../../common/html/icon'
import { LOCATION_TYPE } from '../../../../common/constant'
import { Input } from '../../../../common/input'
import { selectLocationById } from '../../../../common/store/slice'
import { changeCriteria, selectCriteria } from '../../../store/slice'
import classes from './index.module.scss'

export const SelectedItem = ({
  criteriaGroup,
  screeningIndicatorId,
  locationType,
  locationId,
}) => {
  const dispatch = useDispatch()
  const location = useSelector(selectLocationById(locationId))
  const locationById = useSelector(selectLocationById())

  const selectedData =
    useSelector(
      selectCriteria([criteriaGroup, screeningIndicatorId, 'data']),
    ) || []

  const handleDelete = () => {
    let newSelectedData = JSON.parse(JSON.stringify(selectedData))

    switch (locationType) {
      case LOCATION_TYPE.PROVINCE:
        newSelectedData = newSelectedData.filter((data) => {
          return data.Province.LocationId !== locationId
        })
        break
      case LOCATION_TYPE.DISTRICT:
        const parentProvinceId = locationById[location.parentId]?.id
        if (parentProvinceId) {
          const provinceIndex = newSelectedData.findIndex(
            (data) => data.Province.LocationId === parentProvinceId,
          )
          if (provinceIndex !== -1) {
            newSelectedData[provinceIndex].Province.Districts = newSelectedData[
              provinceIndex
            ].Province.Districts.filter(
              (district) => district.LocationId !== locationId,
            )
          }
        }
        break
      default:
        return
    }

    dispatch(
      changeCriteria({
        path: [criteriaGroup, screeningIndicatorId, 'data'],
        data: newSelectedData,
      }),
    )
  }

  return (
    <Element className={`dFlex ${classes.mt6}`}>
      <Input
        value={location.name}
        disabled
        readOnly
        suffix={
          <Icon
            className="icon-delete-circle-fill"
            style={{ fontSize: 16, color: '#9C9C9C' }}
            onClick={handleDelete}
          />
        }
        wrapperClassname="w100"
        wrapperStyle={{ padding: '5px 12px' }}
      />
    </Element>
  )
}
